import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {ActivatedRoute, Router} from "@angular/router";
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {ApiResponseDto} from "../../../core/interfaces/core.types";
import {SignUpService} from "../../service/sign-up.service";
import {RegistrationApiService} from "../../api/registration-api.service";


@Component({
    selector: 'rg-sign-up',
    templateUrl: './sign-up.component.html',
    styleUrls:['./sign-up.component.css']
})
export class SignUpComponent extends CoreComponent {

  formGroup: FormGroup | null = null;
  errorMessage: string | null = null;

  constructor(protected registrationService: RegistrationApiService,
              protected signUpService: SignUpService,
              protected formBuilder: FormBuilder,
              protected route: ActivatedRoute,
              protected router: Router) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.route.queryParams.subscribe(params => {

      if (params["guid"]) {
        this.registrationService.setReferralGuid(params['guid']);
      }

    });

    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {

    //start sign-up service to clear the phone number
    this.signUpService.start();
    this.createFormGroup();
    this.refreshComponent();
  }

  createFormGroup() {
    this.formGroup = this.formBuilder.group({
      phoneNumber: new FormControl(null, [Validators.required, this.minDigitsValidator(8)])
    });
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {

    this.initialized = true;
  }

  /**
   * Process changes within Binding.
   * @param changes
   */
  override ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["id"]) {
      this.refreshComponent();
    }
  }

  /**
   * Destroy component.
   */
  override ngOnDestroy(): void {

  }

  handleRequestOtpCode() {

    this.busy = true;

    if (this.formGroup) {
      const phoneNumber = '+49' + this.formGroup.get('phoneNumber')?.value;
      this.signUpService.phoneNumber = phoneNumber;
      this.registrationService.requestOtp(phoneNumber).subscribe((res: ApiResponseDto) => {
        this.router.navigate(['/sign-up/otp'])
        this.busy = false;
      },error => {
        this.errorMessage = error.error.data;
        this.busy = false;
      })
    }
  }

  navigateToLogin() {
    this.router.navigate(['/login'])
  }

  handleInputNumber() {
    const value = this.formGroup?.get('phoneNumber')?.value;

    if (!value || value.toString().length < 8) {
      this.formGroup?.setErrors({invalid: true});
    }
    this.formGroup?.setErrors(null);
  }

  minDigitsValidator(minDigits: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      const valueStr = value?.toString() || '';
      return valueStr.length >= minDigits ? null : { 'minDigits': { value: control.value } };
    };
  }

}
